import { Paper, Table, TableContainer } from '@mui/material'
import React from 'react'

function StyledTableContainer({ children, height, size, pl, pr, width, isStickyHeader }) {
    return (
        <Paper sx={{ width: width ? width : "100%", overflow: 'hidden', height: height ? height : "85%", pl: pl, pr: pr }} elevation={0}>
            <TableContainer sx={{ maxHeight: "100%" }} >
                <Table aria-label="simple table" size={size || "small"} stickyHeader={isStickyHeader} >
                    {children}
                </Table>
            </TableContainer>
        </Paper>
    )
}
export default StyledTableContainer